//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  filterCardDiv: {
    marginTop: 10,
    display: "flex",
    justifyContent: "right",
  },
  filterCard: {
    backgroundColor: "#ededed",
    border: " 1px solid #707070",
    borderRadius: "20px !important",
    zIndex: 100,
  },
  filterCardNonSales: {
    backgroundColor: "#ededed",
    border: " 1px solid #707070",
    borderRadius: "20px !important",
    zIndex: 100,
    width: "70%",
    float: "right",
    "@media (max-width: 1000px)": {
      width: "100%"
    }
  },
  filterCardGridContainer: {
    padding: 15,
    height: "100%",
  },
  filterCardGrid: {
    borderRight: "1px solid #000",
    padding: "5px !important",
    "@media (max-width: 959px)": {
      borderRight: "none",
    },
  },
  filterCardHeadText: {
    fontWeight: "bold",
    fontSize: 16,
  },
  filterCardSubHeadText: {
    fontSize: 24,
  },
  filterCardInput: {
    borderRadius: 10,
  },
  filterCardBtnGrid: {
    textAlign: "center",
    alignSelf: "center",
  },
  filterCardResetBtn: {
    color: "#4472c4",
    backgroundColor: "#fff!important",
    fontSize: 14,
    border: " 1px solid #4472c4",
    borderRadius: 10,
    width: 100,
    height: 35,
    textTransform: "capitalize",
    marginLeft: 20,
    marginTop: 10,
  },
  filterCardApplyBtn: {
    color: "#fff",
    backgroundColor: "#4472c4",
    fontSize: 14,
    border: " 1px solid #4472c4",
    borderRadius: 10,
    width: 130,
    float: "right",
    height: 35,
    textTransform: "capitalize",
    margin: "0px 20px",
    "&:hover": {
      backgroundColor: "#4472c4",
    },
    "@media (max-width: 600px)": {
      float: "right",
    },
  },
  searchInput: {
    width: "90%",
  },
  badge: {
    backgroundColor: "#C52025",
    color: "#fff",
    fontWeight: "bold",
  },
  applyBtnDiv_1: {
    marginTop: 10,
    marginLeft: -20,
    display: "flex",
    float: "right",
    flexDirection: "column",
  },
  applyBtnDiv_2: {
    marginTop: 50,
    display: "flex",
    float: "right",
    flexDirection: "column",
  },
  searchInputContainer: {
    width: "100%",
    marginRight: 20,
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  fiterCardClose: {
    float: "right",
    marginTop: "-5px",
    marginBottom: 5,
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  fiterCardCloseOne: {
    float: "right",
    marginTop: "-5px",
    marginBottom: 5,
    display: "none",
    "@media (max-width: 768px)": {
      display: "inline",
    },
  },
}));

export default useStyles;
